import { DownloadItem } from '../../../DownloadItem/DownloadItem.client';

export type DataSheetsProps = {
  dataSheetUrls: string[];
};

export const DataSheets = ({ dataSheetUrls }: DataSheetsProps) => (
  <div className="flex flex-col items-center gap-1">
    {dataSheetUrls.map((datasheet, index) => (
      <DownloadItem
        key={datasheet}
        link={datasheet}
        type="PRODUCT_DATASHEET"
        linkTextExtension={dataSheetUrls.length > 1 ? index + 1 : undefined}
        renderIcon={false}
      />
    ))}
  </div>
);
